import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HotToastService } from '@ngxpert/hot-toast';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { OpbCompanyFormComponent } from '../opb-company-form/opb-company-form.component';
import { OpbCompanyService } from '../../../services/opb-company.service';
import { OpbCompanyDto } from '../../../models/api/opbCompanyDto';
import { HasUnsavedChanges } from '../../../guards/unsaved-changes.guard';

@Component({
  selector: 'app-opb-company-edit',
  imports: [
    OpbCompanyFormComponent,
    NgxSpinnerModule
  ],
  templateUrl: './opb-company-edit.component.html',
  styleUrl: './opb-company-edit.component.scss'
})
export class OpbCompanyEditComponent implements OnInit, HasUnsavedChanges {
  @ViewChild(OpbCompanyFormComponent) companyForm?: OpbCompanyFormComponent;

  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private opbCompanyService = inject(OpbCompanyService);
  private toast = inject(HotToastService);
  private spinnerService = inject(NgxSpinnerService);

  companyId: string | null = null;
  companyData: OpbCompanyDto | null = null;

  hasUnsavedChanges(): boolean {
    return this.companyForm?.hasUnsavedChanges() ?? false;
  }

  ngOnInit(): void {
    this.companyId = this.route.snapshot.paramMap.get('id');
    if (this.companyId) {
      this.loadCompany();
    }
  }

  private loadCompany(): void {
    this.spinnerService.show();
    this.opbCompanyService.getOpbCompanyById(this.companyId!).subscribe({
      next: (company) => {
        this.companyData = company;
        this.spinnerService.hide();
      },
      error: () => {
        this.spinnerService.hide();
        this.toast.error('Failed to load OPB Company');
        this.router.navigate(['/companies', 'opb-list']);
      }
    });
  }

  onCancel(): void {
    this.router.navigate(['/companies', 'opb-list']);
  }
}
